
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.417 14.145s.66-.701.908-1.32v.536H9.89v-.7l-1.154-1.155s.206-1.526.206-2.268V8.083h.412s0 .537.207.537.247-.33.247-.537v-.33h-.412v.124h-.413V5.692h.413s0 .536.206.536.247-.33.247-.536v-.33h-.412v.124h-.412C8.984 4.744 8.819 2.105 7.5.868 6.18 2.105 5.974 4.744 5.974 5.486h-.412v-.124H5.15v.33c0 .206.04.536.247.536s.206-.536.206-.536h.412v2.185h-.412v-.123h-.412v.33c0 .247.041.536.247.536s.206-.537.206-.537h.413v1.155c0 .783.206 2.268.206 2.268L5.108 12.66v.701h1.567v-.536c.083.619.742 1.32.742 1.32z"}})])
          )
        }
      }
    